var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoWorkingSpaceSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 55,
    fill: "none",
    viewBox: "0 0 96 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 17,
    x: 19.125,
    y: 19,
    fill: "#D9D9D9",
    rx: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.125,
    cy: 27,
    r: 7,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.125,
    cy: 48,
    r: 7,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.125,
    cy: 27,
    r: 7,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.125,
    cy: 48,
    r: 7,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.125,
    cy: 7,
    r: 7,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.125,
    cy: 7,
    r: 7,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#98A2B3",
    d: "M28.125 22h10v2h-10zm0 9h10v2h-10zm28-9h10v2h-10zm15 11V23h2v10zm-50 0V23h2v10zm35-2h10v2h-10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoWorkingSpaceSpace);
export default __webpack_public_path__ + "static/media/co-working-space-space.cfe181f65d8c6aaac68152ca01f42f0f.svg";
export { ForwardRef as ReactComponent };